import statesData from './statesData.json';

export default {
    data: statesData
};
